import { DashboardPage,DashboardListPage} from './pages';
import { withNavigationWatcher } from './contexts/navigation';

const routes = [
    {
        path: '/dashboard',
        element: DashboardPage
    },
    {
        path: '/dashboardList',
        element: DashboardListPage
    }
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
